export default {"src":"/_next/static/media/SubDesc3.8ce7b33b.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};